// Customer Recharge Service
import api from '../api/api';
import { ApiResponse } from '../api/api';
import apiUrls from '../api/apiUrls';
import {
    CalculateRechargeAmountRequest,
    CalculateRechargeAmountResponse,
    CreateCashPaymentRequest,
    CreateCashPaymentResponse,
    GetCashRechargeDetailsRequest,
    GetCashRechargeDetailsResponse,
    GetRealtimeBalanceRequest,
    GetRealtimeBalanceResponse,
    ApplyCouponCodeRequest,
    ApplyCouponCodeResponse,
} from '../interface/CustomerRecharge';


export const getCashRechargeDetails = async (
    request: GetCashRechargeDetailsRequest,
    signal?: AbortSignal
): Promise<ApiResponse<GetCashRechargeDetailsResponse>> => {
    try {
        const response: ApiResponse<GetCashRechargeDetailsResponse> = await api.post(
            apiUrls.GetCashRechargeDetails,
            { customerId: request.customerId },
            { signal }
        );
        return response;
    } catch (error: any) {
        throw error;
    }
};

export const getRealtimeBalance = async (
    request: GetRealtimeBalanceRequest,
    signal?: AbortSignal
): Promise<ApiResponse<GetRealtimeBalanceResponse>> => {
    try {
        const response: ApiResponse<GetRealtimeBalanceResponse> = await api.post(
            apiUrls.GetRealtimeBalance,
            { customerId: request.customerId },
            { signal }
        );
        return response;
    } catch (error: any) {
        throw error;
    }
};

export const calculateRechargeAmount = async (
    request: CalculateRechargeAmountRequest,
): Promise<ApiResponse<CalculateRechargeAmountResponse>> => {
    // Prepare payload as per new API contract

    try {
        const response: ApiResponse<CalculateRechargeAmountResponse> = await api.post(apiUrls.CalculateRechargeAmount, request);
        return response;
    } catch (error: any) {
        throw error;
    }
};

export const createCashPayment = async (
    request: CreateCashPaymentRequest,
): Promise<ApiResponse<CreateCashPaymentResponse>> => {
    try {
        const response: ApiResponse<CreateCashPaymentResponse> = await api.post(apiUrls.CreateCashPayment, request);
        return response;
    } catch (error: any) {
        throw error;
    }
};

export const applyCouponCode = async (
    payload: ApplyCouponCodeRequest
): Promise<any> => {
    try {
        const response: ApiResponse<ApplyCouponCodeResponse> = await api.post(
            apiUrls.ApplyCouponCode,
            payload
        );
        return response;
    } catch (error: any) {
       throw error;
    }
}

export default {
    getCashRechargeDetails,
    getRealtimeBalance,
    calculateRechargeAmount,
    createCashPayment,
    applyCouponCode
};
